import { SuggestionData } from './suggestion-data';

export class Suggestion {
	id?: string;
	name: string;
	isMatched: boolean;
	isSuggested: boolean;
	isSelected?: boolean;
	readOnly?: boolean;

	constructor(data: SuggestionData & { isSelected?: boolean; readOnly?: boolean }) {
		this.id = data.id;
		this.name = data.name;
		this.isMatched = data.matched;
		this.isSuggested = !data.id;
		this.isSelected = data.isSelected ?? false;
		this.readOnly = data.readOnly ?? false;
	}
}
